import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekday from 'dayjs/plugin/weekday';

import { createI18n } from 'vue-i18n';

import en from './i18n/en.json';
import fr from './i18n/fr.json';
import nl from './i18n/nl.json';

import nxtStylesEn from '@nxtpeople/nxt-styles/dist/translations/en.json';
import nxtStylesFr from '@nxtpeople/nxt-styles/dist/translations/fr.json';
import nxtStylesNl from '@nxtpeople/nxt-styles/dist/translations/nl.json';

const userAgentLocale = window.navigator.language.substring(0, 2);
const savedLocale = window.localStorage.getItem('locale');
const locale = savedLocale || userAgentLocale || 'nl';

dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(weekday);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(updateLocale);

dayjs.locale(locale);
dayjs.updateLocale(locale, { weekStart: 1 });

const i18n = createI18n({
   legacy: false,
   locale,
   fallbackLocale: 'nl',
   messages: {
      nl: { ...nl, ...nxtStylesNl },
      en: { ...en, ...nxtStylesEn },
      fr: { ...fr, ...nxtStylesFr },
   },
   globalInjection: true,
});

export default i18n;
